<template>
  <div class="dass-orders-filter-container q-mt-md q-pa-md border-grey-4 shadow-1">
    <div class="q-mb-sm">
      <h3 class="q-ma-none text-bold text-uppercase" style="font-size: 1.1rem; line-height: 1.5rem;">
        {{ $t('dass.filterMyOrders') }}
      </h3>
      <span class="text-caption text-grey-7">
        {{ $t('dass.filterMyOrdersSubtitle') }}
      </span>
    </div>
    
    <div class="row items-start q-gutter-md q-mt-xs dass-mobile-container">
      
      <div class="flex q-gutter-sm dass-mobile-group">
        <q-btn 
          unelevated 
          dense           
          :class="['dass-btn-filter', activePreset === '90' ? `dass-color-button-order-${brandName}` : `dass-color-button-order-inactive-${brandName}`]"
          :label="$t('dass.last90Days')"
          @click="changePreset('90')"
        />
        <q-btn 
          unelevated 
          dense           
          :class="['dass-btn-filter', activePreset === '365' ? `dass-color-button-order-${brandName}` : `dass-color-button-order-inactive-${brandName}`]"
          :label="$t('dass.last12Months') || 'Últimos 12 Meses'"
          @click="changePreset('365')"
        />
        <q-btn 
          unelevated 
          dense           
          :class="['dass-btn-filter', activePreset === 'custom' ? `dass-color-button-order-${brandName}` : `dass-color-button-order-inactive-${brandName}`]"
          :label="$t('dass.customPeriod')"
          @click="activePreset = 'custom'"
        />
      </div>

      <div v-if="activePreset === 'custom'" class="flex items-start q-gutter-sm dass-animate-fade dass-mobile-group">
        <q-input 
          outlined 
          dense 
          type="date" 
          v-model="filterDates.start" 
          label="De" 
          stack-label
          :min="minAllowedDate"
          :max="maxAllowedDate"
          :class="`dass-input-global dass-select-filter-${brandName}`"
          hide-bottom-space
          @update:model-value="triggerCustomFilter"
        />
        
        <q-input 
          outlined 
          dense 
          type="date" 
          v-model="filterDates.end" 
          label="Até" 
          stack-label
          :min="minAllowedDate"
          :max="maxAllowedDate"
          :class="`dass-input-global dass-select-filter-${brandName}`"
          :error="dateError"
          :error-message="$t('dass.rangeDateMax12Months')"
          hide-bottom-space
          @update:model-value="triggerCustomFilter"
        />
        
        <q-btn 
          @click="changePreset('90')" 
          round 
          dense 
          flat 
          icon="mdi-filter-remove-outline" 
          :class="`dass-color-button-order-${brandName} dass-clear-btn`"
        >
          <q-tooltip class="bg-black">{{ $t('dass.cleanFilters') }}</q-tooltip>
        </q-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { useIsSafari } from '@/composables/useIsSafari'
import { mapGetters, mapActions } from 'vuex'
import moment from '@/helpers/date/moment' 

export default {
  name: 'OrderFilterBar',
  emits: ['filter-change'],
  setup() {    
    const { isSafari, brandName } = useIsSafari()    
    return { isSafari, brandName }     
  },
  data() {
    return {
      activePreset: '90',
      dateError: false, 
      filterDates: { start: '', end: '' }
    }
  },
  computed: {
      ...mapGetters('orders', ['getActiveFilterDate']), 
      minAllowedDate() {
        return moment().subtract(12, 'months').format('YYYY-MM-DD');
      },     
      maxAllowedDate() {
        return moment().format('YYYY-MM-DD');
      }
  },
  mounted() {    
    const savedFilterState = this.getActiveFilterDate
    if (savedFilterState) {
      this.activePreset = savedFilterState.preset;
      this.filterDates.start = savedFilterState.start;
      this.filterDates.end = savedFilterState.end;
    }
  },
  methods: {
    ...mapActions('orders', ['setFilterDate']),
    
    getDateParams(preset) {
        const hoje = moment().format('YYYY-MM-DD');
        
        if (preset === '90') {
          return {
            data_inicio: moment().subtract(90, 'days').format('YYYY-MM-DD'),
            data_fim: hoje
          }
        }        
        if (preset === '365') {
          return {
            data_inicio: moment().subtract(12, 'months').format('YYYY-MM-DD'),
            data_fim: hoje
          }
        }
        if (preset === 'custom' && this.filterDates.start && this.filterDates.end) {
          return {
            data_inicio: this.filterDates.start,
            data_fim: this.filterDates.end
          }
        }
        return {} 
    },
    
    changePreset(preset) {
        this.activePreset = preset;
        this.dateError = false; 

        if (preset !== 'custom') {
          this.filterDates.start = '';
          this.filterDates.end = '';
        }  
        const params = this.getDateParams(preset);    
        
        this.setFilterDate({
          preset: preset,
          start: this.filterDates.start,
          end: this.filterDates.end,
          params: params 
        });

        this.$emit('filter-change', params);
    },
    
    triggerCustomFilter() {
        this.dateError = false; 
        const { start, end } = this.filterDates;    
        
        if (start && end) {
             const mStart = moment(start, 'YYYY-MM-DD');
             const mEnd = moment(end, 'YYYY-MM-DD');               
             const minDate = moment().subtract(12, 'months').startOf('day');
             const maxDate = moment().endOf('day');

           
             if (mEnd.isBefore(mStart)) return;
             if (mStart.isBefore(minDate) || mEnd.isAfter(maxDate)) {
                this.dateError = true;
                this.filterDates.start = '';
                this.filterDates.end = '';
                return;
             }
             
             const limitEndDate = mStart.clone().add(12, 'months');
             if (mEnd.isAfter(limitEndDate)) {
                this.dateError = true;
                this.filterDates.start = '';
                this.filterDates.end = '';
                return;
             }             
            
             const params = this.getDateParams('custom');      
             
             this.setFilterDate({
               preset: 'custom',
               start: start,
               end: end,
               params: params
             });

             this.$emit('filter-change', params);
        }
    }
  }
}
</script>

<style lang="scss" scoped>
/* Todo o seu estilo SCSS impecável (Desktop, Mobile, Umbro, Fila, NewBalance) permanece idêntico aqui! */
.dass-orders-filter-container {
  background: #ffffff;
  border-radius: var(--border-radius-card, 8px);
}

.dass-animate-fade {
  animation: fadeInDass 0.25s ease-out;
}

@keyframes fadeInDass {
  from { opacity: 0; transform: translateY(-3px); }
  to { opacity: 1; transform: translateY(0); }
}

.dass-clear-btn {
  height: 45px !important;
  width: 50px !important;
  min-height: 45px !important;
  padding: 0 !important;
}

.dass-input-global :deep(.q-field__control) {
  height: 45px !important;
  min-height: 45px !important;  
}
.dass-btn-filter {
  height: 45px !important;
  min-height: 45px !important;
}

/* ### UMBRO ### */
.dass-color-button-order-umbro {
  color: var(--theme-white) !important;
  background-color: var(--color-default-umbro) !important;
  border-radius: var(--border-radius-button-umbro, 0px) !important;  
  border: 2px solid var(--color-default-umbro) !important;
  padding: var(--space__0-25x) var(--space) !important;
  font-weight: bold;
}
.dass-color-button-order-inactive-umbro {
  color: var(--color-fila-primary) !important;
  background-color: #ffffff !important;
  border-radius: var(--border-radius-button-umbro, 0px) !important;
  border: 2px solid var(--color-fila-primary) !important;
  padding: var(--space__0-25x) var(--space) !important;
  font-weight: bold;
  transition: all 0.3s ease !important;
  
  &:hover {
    background-color: var(--color-default-umbro) !important;    
    color: var(--theme-white) !important;
  }
}
.dass-select-filter-umbro {
  :deep(.q-field__control) {
    border-radius: var(--border-radius-button-umbro, 0px) !important;
  }
  &.q-field--focused :deep(.q-field__control:after) {
    border-color: var(--color-default-umbro) !important;
  }
}

/* ### FILA ### */
.dass-color-button-order-fila {
  color: var(--theme-white) !important;
  background-color: var(--color-fila-primary) !important;
  border-radius: var(--border-radius-button-fila, 30px) !important; 
  border: 2px solid var(--color-fila-primary) !important;
  padding: var(--space__0-25x) var(--space) !important;
  font-weight: bold;
}
.dass-color-button-order-inactive-fila {
  color: var(--color-fila-primary) !important;
  background-color: #ffffff !important;
  border-radius: var(--border-radius-button-fila, 30px) !important;
  border: 2px solid var(--color-fila-primary) !important;
  padding: var(--space__0-25x) var(--space) !important;
  font-weight: bold;
  transition: all 0.3s ease !important;

  &:hover {
    background-color: var(--color-fila-primary) !important;  
    color: var(--theme-white) !important;
    border: 2px solid var(--color-fila-primary) !important;
  }
}
.dass-select-filter-fila {
  :deep(.q-field__control) {
    border-radius: var(--border-radius-button-fila, 30px) !important;
  }
  &.q-field--focused :deep(.q-field__control:after) {
    border-color: var(--color-fila-primary) !important;
  }
}

/* ### NEW BALANCE ### */
.dass-color-button-order-newbalance {
  color: var(--theme-white) !important;
  background-color: var(--color-default-new-balance) !important;
  border-radius: var(--border-radius-button-newbalance, 4px) !important; 
  border: 2px solid var(--color-default-new-balance) !important;
  padding: var(--space__0-25x) var(--space) !important;
  font-weight: bold;
}
.dass-color-button-order-inactive-newbalance {
  color: var(--color-default-new-balance, #E5788B) !important;
  background-color: #ffffff !important;
  border-radius: var(--border-radius-button-newbalance, 4px) !important;
  border: 2px solid var(--color-default-new-balance) !important;
  padding: var(--space__0-25x) var(--space) !important;
  font-weight: bold;
  transition: all 0.3s ease !important;

  &:hover {
    background-color: var(--color-default-new-balance) !important;
    color: var(--theme-white) !important;
  }
}
.dass-select-filter-newbalance {
  :deep(.q-field__control) {    
    border-radius: var(--border-radius-button-newbalance, 4px) !important;
  }
  &.q-field--focused :deep(.q-field__control:after) {
    border-color: var(--color-default-new-balance) !important;
  }
}

@media (max-width: 576px) { 
  .dass-mobile-container {
    flex-direction: column !important;
    align-items: stretch !important;
    margin-left: 0 !important; 
  }

  .dass-mobile-group {
    flex-direction: column !important;
    width: 100% !important;
    margin-left: 0 !important;     
    
    > * {
      width: 100% !important;
      margin-left: 0 !important; 
      margin-top: 8px !important;
    }
        
    .dass-btn-filter {
      padding: var(--space__0-5x) var(--space__0-75x) !important;      
    }
    .dass-clear-btn {
       width: 100% !important;
       border-radius: 4px !important;
    }
  }
}
</style>